/**
 * Selected Class Slice
 */
import { createSlice } from '@reduxjs/toolkit';


export const selectedClassSlice = createSlice({
    name: 'selectedClass',
    initialState: {
        data: {},
        subject: {},
    },
    reducers: {
        setSelectedClass: (state, action) => {
            state.data = action.payload;
        },
        setSubject: (state, action) => {
            state.subject = action.payload;
        },
        setClassAndSubject: (state, action) => {
            state.data = action.payload.class;
            state.subject = action.payload.subject;
        }
    },
});

export const { setSelectedClass, setSubject, setClassAndSubject } = selectedClassSlice.actions;
export default selectedClassSlice.reducer;
